/* eslint-disable global-require */

import {
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import VueRecaptcha from 'vue-recaptcha'
import { mapActions } from 'vuex'
import store from '@/store'
import { changeLang } from '@/auth/utils'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      language: process.env.VUE_APP_DEFAULT_LANGUAGE,
      rememberMe: !!localStorage.getItem('Remail'),
      form: {
        email: localStorage.getItem('Remail') || '',
        password: '',
        recaptcha: null,
      },
      sideImg: '',
      required,
      email,
      pending: false,
      options: [
        {
          title: 'English',
          locale: 'en',
          url: require('@/assets/images/flags/en.png'),
        },
        {
          title: 'Farsi',
          locale: 'fa',
          url: require('@/assets/images/flags/IR.png'),
        },
        {
          title: 'Arabic',
          locale: 'ar',
          url: require('@/assets/images/flags/AR.png'),
        },
        {
          title: 'China',
          locale: 'cn',
          url: require('@/assets/images/flags/CN.png'),
        },
        {
          title: 'Czech',
          locale: 'cs',
          url: require('@/assets/images/flags/cs.png'),
        },
        {
          title: 'Russia',
          locale: 'ru',
          url: require('@/assets/images/flags/RU.png'),
        },
      ],
    }
  },
  computed: {
    mediaType() {
      return (`${process.env[`VUE_APP_LOGIN_MEDIA_TYPE_${this.$i18n.locale.toUpperCase()}`]}`)
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    mediaUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = `${process.env[`VUE_APP_LOGIN_MEDIA_${this.$i18n.locale.toUpperCase()}`]}`
        return this.sideImg
      }
      return `${process.env[`VUE_APP_LOGIN_MEDIA_${this.$i18n.locale.toUpperCase()}`]}`
    },
    sitekey() {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY
    },
    isSecondaryLoginPageDesignEnabled() {
      return process.env.VUE_APP_ENABLE_SECONDARY_LOGIN_PAGE_DESIGN === 'true'
    },
  },
  created() {
    if ('activated' in this.$route.query) {
      this.$swal({
        title: this.$t('success_activation'),
        icon: 'success',
        timer: 2500,
        showConfirmButton: false,
      })
    } else if ('notactivated' in this.$route.query) {
      this.$swal({
        title: this.$route.query.message ? this.$route.query.message : this.$t('failed_activation'),
        icon: 'warning',
        timer: 3000,
        showConfirmButton: false,
      })
    }
  },
  beforeCreate() {
    if (!localStorage.getItem('authenticated') || !localStorage.getItem('token')) {
      this.$store.commit('SET_AUTHENTICATED', false)
    }
  },
  methods: {
    ...mapActions(['login']),
    changeLang(val) {
      changeLang(val.locale)
    },
    async submit() {
      this.pending = true
      this.login(this.form).then(response => {
        localStorage.setItem('email', this.form.email)
        if (this.rememberMe) {
          localStorage.setItem('Remail', this.form.email)
        } else {
          localStorage.removeItem('Remail')
        }
        if (response.type === 'has Two Factor') {
          this.$swal({
            title: this.$t('two_factor_message'),
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          this.$router.push(`/${response.lang}/login-section2${this.$route.query.redirect ? `?redirect=${this.$route.query.redirect}` : ''}`)
        } else if (response.type === 'login') {
          window.dataLayer.push({
            event: 'login',
          })
          this.$swal({
            title: this.$t('login_message'),
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          this.$router.push(`${this.$route.query.redirect ? `${this.$route.query.redirect}` : `/${response.lang}/dashboard`}`)
        }
      }).finally(() => {
        this.pending = false
        this.onCaptchaExpired()
      })
    },
    onVerify(response) {
      this.form.recaptcha = response
    },
    async onCaptchaExpired() {
      this.$refs.recaptcha.reset()
      this.form.recaptcha = null
    },
  },
}
